import { DirtyModel } from "./interfaces/dirty_model";
import { Wallet } from "./interfaces/wallet";
import { PaymentOption } from "./payment_option";

export class VoucherOffer extends DirtyModel {
	public accepted_terms_data: boolean = false;
	public metal_terms_data: boolean = false;

	private payment_option_id: string = "";
	private wallet_id: string = "";
	private asset_id: string = "";
	private code: string = "";
	private fiat_id = "1";

	public get _code(): string {
		return this.code;
	}

	public set _code(s: string) {
		this.code = s;
	}

	public getPaymentOptionId(): string {
		return this.payment_option_id;
	}

	public setPaymentOptionId(value: string): void {
		this.payment_option_id = value;
	}

	public setPaymentOption(p: PaymentOption): void {
		this.setPaymentOptionId(p.getId());
	}

	public getAssetId(): string {
		return this.asset_id;
	}

	public setAssetId(id: string): void {
		this.asset_id = id;
	}

	public getWalletId(): string {
		return this.wallet_id;
	}

	public setWalletId(value: string): void {
		this.wallet_id = value;
	}

	public setWallet(w: Wallet): void {
		this.setWalletId(w.getId());
	}

	public getCode(): string {
		return this.code;
	}

	public setCode(value: string): void {
		this.code = value;
	}
}
